import Component from ".";
import authRoles from "../../utils/auth.roles";
const AuthRoutes = {
  auth: authRoles.guest,
  kyc: false,
  mfaNotRequired: true, 
  routes: [
    {
      path: "/login",
      component: Component,
      exact: true,
    },
    {
      path: "/login/:code",
      component: Component,
      exact: true,
    },
    {
      path: "/invite/:code",
      component: Component,
      exact: true,
    }
  ],
};
export default AuthRoutes;
